import { emitter } from '@phoenix/event-bus';
import { orderLinesLocalStorageHelper } from '@phoenix/helpers/product-localstorage-helper';
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('cartPreview', ['countFromLocalStorage']),

    isHidden() {
      return this.countFromLocalStorage === 0;
    },
  },

  created() {
    emitter.on('shopping-badge-update', this.updateShoppingBagCount);
    const count = orderLinesLocalStorageHelper.get();
    this.updateShoppingBagCount(count);
  },

  methods: {
    ...mapActions('cartPreview', ['updateShoppingBagCount']),
  },
};
